import { createContext, useContext, useState, useCallback } from "react";
import RFQModal from "./RFQModal";

const RFQContext = createContext(null);

export function RFQProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [prefill, setPrefill] = useState({});

  const openRFQ = useCallback((p = {}) => {
    setPrefill(p);
    setOpen(true);
  }, []);

  return (
    <RFQContext.Provider value={{ openRFQ }}>
      {children}
      <RFQModal open={open} onOpenChange={setOpen} prefill={prefill} />
    </RFQContext.Provider>
  );
}

export function useRFQ() {
  return useContext(RFQContext);
}
